import styled from 'styled-components';
import resetCSS from '../../styles/reset';

const DivStyled = styled.div`
    ${resetCSS}
    border-radius: 50%;
    display: inline-flex;
    overflow: hidden;
`;

export default {
    DivStyled,
};
